import React, { useState, useEffect } from "react";
import { getFromLocalStorage } from "../../utils/common-utils";
import { Link, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../context/AppContext";
import {
  setToLocalStorage,
} from "../../utils/common-utils";
import { ChangePasswordPrivate, LogoutUser } from "../../api/Api";
import logomobile from "../../assets/images/altruist_logo.png";


import "./sidebar.css";

const SideBar = () => {
  const sidebaritems = getFromLocalStorage("sideMenus");
  const [expandedMenus, setExpandedMenus] = useState({});
  const location = useLocation();


  const navigate = useNavigate();
  const { setContextStates } = React.useContext(AppContext);
  const userData = getFromLocalStorage("userData");
  console.log("userDate", userData);
  const [changePasswordModal, setChangePasswordModal] = React.useState(false);
  const [updateProfileModal, setUpdateProfileModal] = React.useState(false);
  const [error, setError] = React.useState(false);
  const [showPassword, setShowPassword] = React.useState(false);
  const [showPassword1, setShowPassword1] = React.useState(false);
  const [showPassword2, setShowPassword2] = React.useState(false);
  const [resetPassword, setResetPassword] = React.useState({
    existingPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [loader, setLoader] = React.useState(false);
  const [profileDetails, setProfileDetails] = React.useState({
    firstName: userData?.firstName || "",
    lastName: userData?.lastName || "",
    email: userData?.email || "",
    username: userData?.username || "",
    mobile: userData?.mobileNo || "",
    streetAddress: userData?.streetAddress || "",
    state: userData?.state || "",
    city: userData?.city || "",
    country: userData?.country || "",
    cpDetailsList: userData?.cpDetailsList || [],
    // Add other fields as needed
  });
  const pass = /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/;
  console.log("profileDetails", profileDetails);

  // Update mobile detection and sidebar state
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth > 768);

  // Handle window resize
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      
      if (mobile) {
        document.body.className = 'skin-blue sidebar-mini mat-typography sidebar-collapse';
        setIsSidebarOpen(false);
      } else {
        document.body.className = 'skin-blue sidebar-mini mat-typography sidebar-open';
        setIsSidebarOpen(true);
      }
    };
    
    // Set initial classes based on screen size
    if (window.innerWidth > 768) {
      document.body.className = 'skin-blue sidebar-mini mat-typography sidebar-open';
    } else {
      document.body.className = 'skin-blue sidebar-mini mat-typography sidebar-collapse';
    }
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Handle sidebar toggle (close only)
  const handleSidebarToggle = () => {
    document.body.className = 'skin-blue sidebar-mini mat-typography sidebar-collapse';
    setIsSidebarOpen(false);
  };

  // Handle submenu item click
  const handleSubmenuClick = () => {
    if (isMobile) {
      document.body.className = 'skin-blue sidebar-mini mat-typography sidebar-collapse';
      setIsSidebarOpen(false);
    }
  };

  const handleLogout = async () => {
    // Show confirmation dialog first
    const result = await Swal.fire({
      title: "Logout Confirmation",
      text: "Are you sure you want to logout?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, logout",
      cancelButtonText: "Cancel",
      reverseButtons: false,
    });

    // If user confirms logout
    if (result.isConfirmed) {
      let payload = {
        userId: getFromLocalStorage("userData")?.id,
      };
      await LogoutUser(payload);
      // Save rememberedCredentials before clearing localStorage
      const rememberedCredentials = getFromLocalStorage(
        "rememberedCredentials"
      );

      // Clear localStorage
      localStorage.clear();

      // Restore rememberedCredentials if it existed
      if (rememberedCredentials) {
        setToLocalStorage("rememberedCredentials", rememberedCredentials);
      }

      navigate("/");
      Swal.fire({
        text: "Logged Out Successfully",
        icon: "success",
        confirmButtonText: "OK",
      });

      setContextStates((prev) => {
        return {
          ...prev,
          actualToken: "",
        };
      });
    }
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    const { existingPassword, newPassword, confirmPassword } = resetPassword;
    if (
      !existingPassword ||
      !newPassword ||
      (newPassword && !pass.test(newPassword)) ||
      !confirmPassword ||
      newPassword !== confirmPassword
    ) {
      setError(true);
    } else {
      setError(false);
      setLoader(true);
      let payload = {
        userId: userData?.id,
        updateId: null,
        oldPassword: existingPassword,
        newPassword: newPassword,
        // emailId: userData?.email,
      };
      const response = await ChangePasswordPrivate(payload);
      console.log("response", response);
      setLoader(false);
      if (response?.statusDescription?.status == 200) {
        setChangePasswordModal(false);
        setError(false);
        setResetPassword({
          existingPassword: "",
          newPassword: "",
          confirmPassword: "",
        });
        Swal.fire({
          text: response?.statusDescription?.description,
          icon: "success",
          confirmButtonText: "OK",
        });
      } else {
        Swal.fire({
          text: response?.statusDescription?.description,
          icon: "info",
          confirmButtonText: "OK",
        });
      }
    }
  };

  // Determine if it's admin profile (similar to adminClass logic)
  const isAdminProfile = profileDetails.cpDetailsList.length > 0;

  const toggleSubmenu = (menuId) => {
    localStorage.removeItem('selectedContentPartnerId');
    setExpandedMenus((prev) => {
      // If clicking the same menu that's already open, close it
      if (prev[menuId]) {
        return {
          ...prev,
          [menuId]: false,
        };
      }
      // If clicking a different menu, close all others and open the clicked one
      return {
        [menuId]: true,

      };
    });
  };

  return (
    <aside id="side_id" className={`main-sidebar ${isSidebarOpen ? 'sidebar-open' : ''}`}>
      <section className="sidebar">
        <span className="logo-lg d-block d-md-none logo_mob_div">
          <div className="d-flex justify-content-between align-items-center">
            <img 
              src={logomobile} 
              alt="logo" 
              className="img-responsive mob_img d-block d-md-none position-relative pt-3" 
            />
            <i 
              className="fas fa-times text-white fs-2 pe-3 mt-3" 
              onClick={handleSidebarToggle}
              style={{ cursor: 'pointer' }}
            ></i>
          </div>
        </span>
        <ul class="sidebar-menu link" data-widget="tree">
          <li
            className={`li_list_icon ${location.pathname === "/dashboard" ? "side_li_active" : ""}`}
            onClick={() => {
              localStorage.removeItem('selectedContentPartnerId');
              localStorage.removeItem('selectedCountry');
              localStorage.removeItem('selectedOperator');
              localStorage.removeItem('selectedPhoneNumber');
              localStorage.removeItem('customerCare_isActive');
              handleSubmenuClick();
            }}
          >
            <Link to="/dashboard" style={{ color: "#B8C7CE" }}>
              <i
                class={`fa fa-tachometer ${location.pathname === "/dashboard" ? "text-light" : ""
                  }`}
              ></i>
              <span
                className={
                  location.pathname === "/dashboard" ? "text-light" : ""
                }
                onClick={() => {
                  localStorage.removeItem('selectedContentPartnerId');
                  localStorage.removeItem('selectedCountry');
                  localStorage.removeItem('selectedOperator');
                  localStorage.removeItem('selectedPhoneNumber');
                  localStorage.removeItem('customerCare_isActive');
                }}
              >
                Dashboard
              </span>{" "}
              <span class="pull-right-container"> </span>
            </Link>
          </li>

          {sidebaritems?.map(
            (menuItem) =>
              menuItem?.isActive && (
                <li
                  className={`li_list_icon ${location.pathname.startsWith(
                    `/${menuItem?.menu?.toLowerCase().replace(/\s+/g, "-")}`
                  )
                      ? "side_li_active"
                      : ""
                    }`}
                  key={menuItem?.id}
                >
                  <a
                    style={{ color: "#B8C7CE" }}
                    onClick={() => toggleSubmenu(menuItem?.id)}
                  >
                    <i className={menuItem?.menuClass}></i>
                    <span>{menuItem?.menu}</span>
                    {menuItem?.subMenu?.length > 0 && (
                      <span className="pull-right-container">
                        <i className={`fa fa-angle-${expandedMenus[menuItem?.id] ? 'down' : 'right'} pull-right`}></i>
                      </span>
                    )}
                  </a>
                  {menuItem?.subMenu?.length > 0 && (
                    <ul
                      className="treeview-menu"
                      style={{
                        display: expandedMenus[menuItem?.id] ? "block" : "none",
                      }}
                    >
                      {menuItem?.subMenu?.map((subItem) => (
                        <li key={subItem?.id}>
                          <Link
                            className="ms-3"
                            to={`/${menuItem?.menu?.toLowerCase().replace(/\s+/g, "-")}/${subItem?.subMenu?.toLowerCase().replace(/\s+/g, "-")}`}
                            style={{ color: "#B8C7CE" }}
                            onClick={handleSubmenuClick}
                          >
                            <i
                              class={`fa-regular fa-circle ${location.pathname.startsWith(
                                `/${menuItem?.menu
                                  ?.toLowerCase()
                                  .replace(/\s+/g, "-")}/${subItem?.subMenu
                                    ?.toLowerCase()
                                    .replace(/\s+/g, "-")}`
                              )
                                  ? "text-light"
                                  : ""
                                }`}
                            ></i>
                            <span
                              className={
                                location.pathname.startsWith(
                                  `/${menuItem?.menu
                                    ?.toLowerCase()
                                    .replace(/\s+/g, "-")}/${subItem?.subMenu
                                      ?.toLowerCase()
                                      .replace(/\s+/g, "-")}`
                                )
                                  ? "text-light"
                                  : ""
                              }
                            >
                              {subItem?.subMenu}
                            </span>
                          </Link>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              )
          )}
        </ul>
        <nav className="navbar navbar-expand-lg navbar-static-top d-block d-md-none m-0 p-0 mt-4 mt-md-5">
          {/* Sidebar toggle button */}
          {/* <a href="#" className="sidebar-toggle invisible" role="button">
            <span className="sr-only">Toggle navigation</span>
          </a> */}

          {/* <div className="navbar-custom-menu d-flex justify-content-between">
            <ul className="nav navbar-nav w-100">
            
              <li className="user-menu">
                <span className="hidden-xs">
                  Welcome {getFromLocalStorage("userData")?.firstName}{" "}
                  {getFromLocalStorage("userData")?.lastName}!
                </span>
              </li>
              <li className="li_user link pe-1">
                <span>
                  <i className="fa fa-user"></i>
                </span>
                <ul>
                  <li><a onClick={() => setChangePasswordModal(true)}><i className="fa fa-key"></i>Change Password</a></li>
                  <li><a onClick={() => setUpdateProfileModal(true)}><i className="fa fa-user"></i>Update Profile</a></li>
                  <li><a onClick={handleLogout}><i className="fa fa-sign-out"></i>Logout</a></li>
                </ul>
              </li>
            </ul>
          </div> */}
        </nav>
      </section>
    </aside>
  );
};

export default SideBar;
